/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignInResponseDto } from '../../models/sign-in-response-dto';

export interface SignInExternal$Params {
  'X-API-Version'?: string;

/**
 * Authentication type and bearer token
 */
  Authorization: string;
}

export function signInExternal(http: HttpClient, rootUrl: string, params: SignInExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
  const rb = new RequestBuilder(rootUrl, signInExternal.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInResponseDto>;
    })
  );
}

signInExternal.PATH = '/api/session/external';
